import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import './DateSelector.css';

interface DateSelectorProps {
  startDate: Date;
  endDate: Date;
  onDateChange: (startDate: Date, endDate: Date) => void;
}

const DateSelector: React.FC<DateSelectorProps> = ({ startDate, endDate, onDateChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(startDate);
  const [tempEndDate, setTempEndDate] = useState(endDate);

  const handleApply = () => {
    onDateChange(tempStartDate, tempEndDate);
    setIsOpen(false);
  };

  const handleCancel = () => {
    setTempStartDate(startDate);
    setTempEndDate(endDate);
    setIsOpen(false);
  };

  const formatDateRange = () => {
    return `${format(startDate, 'MMM dd, yyyy')} - ${format(endDate, 'MMM dd, yyyy')}`;
  };

  return (
    <div className="date-selector">
      <div className="date-selector-display" onClick={() => setIsOpen(!isOpen)}>
        <img 
          className="date-selector-image-icon" 
          alt="Calendar" 
          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%23616161' stroke-width='2'%3E%3Crect x='3' y='4' width='18' height='18' rx='2' ry='2'%3E%3C/rect%3E%3Cline x1='16' y1='2' x2='16' y2='6'%3E%3C/line%3E%3Cline x1='8' y1='2' x2='8' y2='6'%3E%3C/line%3E%3Cline x1='3' y1='10' x2='21' y2='10'%3E%3C/line%3E%3C/svg%3E"
        />
        <b className="date-range-text">{formatDateRange()}</b>
      </div>
      
      {isOpen && (
        <div className="date-selector-dropdown">
          <div className="date-picker-container">
            <div className="date-picker-section">
              <label>Start Date</label>
              <DatePicker
                selected={tempStartDate}
                onChange={(date) => date && setTempStartDate(date)}
                selectsStart
                startDate={tempStartDate}
                endDate={tempEndDate}
                maxDate={tempEndDate}
                inline
              />
            </div>
            <div className="date-picker-section">
              <label>End Date</label>
              <DatePicker
                selected={tempEndDate}
                onChange={(date) => date && setTempEndDate(date)}
                selectsEnd
                startDate={tempStartDate}
                endDate={tempEndDate}
                minDate={tempStartDate}
                maxDate={new Date()}
                inline
              />
            </div>
          </div>
          <div className="date-selector-actions">
            <button className="btn-cancel" onClick={handleCancel}>Cancel</button>
            <button className="btn-apply" onClick={handleApply}>Apply</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DateSelector;
